import { ITicket } from "interfaces/entities/ticket";

import { IOutboxMessage } from "./outbox-message";
import { createOutboxMessage } from "./outbox-message-factory";
import { OutboxMessageTitles } from "./outbox-message-titles";

export interface ITicketInfoMessage extends IOutboxMessage {
  readonly title: OutboxMessageTitles.TicketInfo;
  readonly data: ITicket;
}

// @ts-expect-error TS(2304): Cannot find name 'ITicketInfoMessageData'.
export function createTicketInfoMessage(pluginId: string, ticketData: ITicketInfoMessageData): ITicketInfoMessage {
  if (!ticketData) {
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'ITicketInfo... Remove this comment to see the full error message
    return null;
  }
  return createOutboxMessage<ITicketInfoMessage>(OutboxMessageTitles.TicketInfo, pluginId, ticketData);
}
